<template>
	<div class="footerDiv">
		<div class="footerOne">
			<div>
				<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="nofollow">鄂ICP备2024070951号-2</a>
			</div>
		</div>
		<div class="footerTwo">
			<div>
				<span>Copyright 2024-2025 湖北省恩施州语之乐艺术培训有限责任公司, All Rights Reserved</span>
			</div>
		</div>
		<div class="footerThree">
			<div>
				<span>公司总部地址：</span><span>湖北省恩施土家族苗族自治州恩施市金子坝街道凤天路113号（天籁园）36栋202</span>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "FooterRow",
		components: {},
		data() {
			return {};
		},
		methods: {}
	};
</script>
<style scoped lang="scss">
	* {
		margin: 0;
		padding: 0;
	}

	.el-footer,
	.footerDiv {
		margin-top: 30px;
		padding: 24px 0;
		width: 100%;
		min-width: 1280px;
		height: 100px !important;
		// background: #303133;
		border-top: 1px solid #f1f1f1;
		user-select: none;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.footerOne,
		.footerTwo,
		.footerThree {
			width: 100%;
			height: 50px;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;

			>div {
				padding: 0 10px;

				span {
					font-size: 14px;
					color: #333;
				}
			}
		}
	}
</style>